import BuzzCard, { BuzzCards } from 'records/BuzzCard';
import Base from 'records/Base';

import {
  BUZZ_ITEM_ASYNC_ACTION_START,
  BUZZ_ITEM_ASYNC_ACTION_ERROR,
  BUZZ_ITEM_ASYNC_ACTION_SUCCESS,
  BUZZ_ITEM_ASYNC_UPDATE_ACTION_SUCCESS,
  BUZZ_ITEM_RESET_STATE,
} from 'actions/buzzCard';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: new BuzzCard(),
});

const actionsMap = {
  [BUZZ_ITEM_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [BUZZ_ITEM_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [BUZZ_ITEM_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: BuzzCards(action.data),
    });
  },
  [BUZZ_ITEM_ASYNC_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: BuzzCards(action.data),
    });
  },
  [BUZZ_ITEM_RESET_STATE]: () => {
    return initialState;
  },
};

export default function buzzCard(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
